import { CART_RECEIVE, CART_SHOW_INFO, CART_ADD_ERROR } from '../constants';

export const cart = (
    state = { quantity: 0, orderTotal: 0, showInfo: false, error: [], clinicalPartActive: false },
    action
) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_SHOW_INFO:
        case CART_ADD_ERROR:
            return {
                ...state,
                ...action.payload,
            };                    
        default:
            return state;
    }
};
